import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyUsSection from './components/WhyUsSection';
import FeaturedProducts from './components/FeaturedProducts';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Set page title and meta tags
    document.title = 'Es Donanım Bilgisayar - 2. El Bilgisayar Alım Satım ve Teknik Servis | Ankara';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da güvenilir 2. el bilgisayar alım satım, ikinci el laptop satışı, bilgisayar tamiri ve teknik servis hizmeti. Uygun fiyat, profesyonel hizmet. Es Donanım Bilgisayar - Ulus, Altındağ');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '2. el bilgisayar, ikinci el bilgisayar, bilgisayar alım satım, bilgisayar tamiri, laptop tamiri, 2. el laptop, teknik servis, Ankara bilgisayar servisi, masaüstü bilgisayar tamiri, notebook tamiri, format atma, anakart tamiri, ekran değişimi, bilgisayar bakım, oyuncu bilgisayarı tamiri, kurumsal bilgisayar servisi, Ulus bilgisayar, Altındağ bilgisayar');
    }
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${siteUrl}/`);
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "@id": `${siteUrl}/#organization`,
          "name": "Es Donanım Bilgisayar",
          "alternateName": "ES Bilgisayar",
          "url": siteUrl,
          "logo": `${siteUrl}/logo.png`,
          "image": `${siteUrl}/og-image.jpg`,
          "description": "Ankara'da güvenilir 2. el bilgisayar alım satım, ikinci el laptop satışı, bilgisayar tamiri ve teknik servis hizmeti",
          "telephone": "+905065376985",
          "email": "info@esbilgisayar.com.tr",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Anafartalar Cad. Ulus Şehir Çarşısı No:3/11",
            "addressLocality": "Altındağ",
            "addressRegion": "Ankara",
            "postalCode": "06030",
            "addressCountry": "TR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "39.9450",
            "longitude": "32.8597"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "09:00",
              "closes": "19:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "09:00",
              "closes": "18:00"
            }
          ],
          "priceRange": "₺₺",
          "areaServed": {
            "@type": "City",
            "name": "Ankara"
          },
          "sameAs": [
            "https://www.facebook.com/esbilgisayar",
            "https://www.instagram.com/esbilgisayar",
            "https://twitter.com/esbilgisayar"
          ]
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Es Donanım Bilgisayar",
          "description": "2. El Bilgisayar Alım Satım ve Teknik Servis",
          "publisher": {
            "@id": `${siteUrl}/#organization`
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${siteUrl}/urunler?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "2. el bilgisayar alırken nelere dikkat etmeliyim?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "2. el bilgisayar alırken ürünün genel durumunu, donanım özelliklerini, garanti durumunu ve satıcının güvenilirliğini kontrol etmelisiniz. Es Donanım Bilgisayar olarak tüm ürünlerimizi test ederek garanti ile sunuyoruz."
              }
            },
            {
              "@type": "Question",
              "name": "Bilgisayar tamiri ne kadar sürer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Arızanın türüne göre değişmekle birlikte, çoğu bilgisayar tamiri 1-3 iş günü içinde tamamlanır. Acil durumlar için aynı gün servis hizmeti de sunuyoruz."
              }
            },
            {
              "@type": "Question",
              "name": "Laptop ekran değişimi yapıyor musunuz?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Evet, tüm marka ve modellerde laptop ekran değişimi hizmeti veriyoruz. Orijinal ve uyumlu ekran seçeneklerimiz mevcuttur."
              }
            },
            {
              "@type": "Question",
              "name": "Eski bilgisayarımı satın alıyor musunuz?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Evet, çalışır durumda olan tüm bilgisayar ve laptopları değerinde satın alıyoruz. Ücretsiz değerlendirme için mağazamıza gelebilir veya bizi arayabilirsiniz."
              }
            }
          ]
        }
      ]
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <FeaturedProducts />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;